import React from 'react'
import { func, object } from 'prop-types'
import { translate } from 'react-i18next'
import { withRouter } from 'react-router'
import { stores, view } from '../../../stores'
import { Loader } from '../../../components/ui/states/Loader'
import { InquiryTypes } from '../../../constants/InquiryTypes'
import { InquiryFrequencies } from '../../../constants/InquiryFrequencies'
import { ProposalsWaiting } from './ProposalsWaiting'
import { InquiryPage } from '../InquiryPage'
import { InquiryStatus } from '../../../constants/InquiryStatus'
import { ProposalsAccepted } from './ProposalsAccepted'
import { ProposalStatus } from '../../../constants/ProposalStatus'
import { InquiryDetails } from '../../../components/inquiries/InquiryDetails'
import { InquiryDetailsTextBlock } from '../../../components/inquiries/InquiryDetailsTextBlock'
import { PagesPaths } from '../../../constants/Pages'

class InquiryRealisationPageComponent extends InquiryPage {
  get type () { return InquiryTypes.REALISATION }
  get frequency () { return InquiryFrequencies.PONCTUAL }

  selected (id) {
    stores.inquiries.select({ proposal: id })
  }

  componentDidMount () {
    super.componentDidMount()
    stores.avanceImmediate.refreshInfos()
  }

  async onCloseSearch () {
    const { history } = this.props
    await stores.inquiries.close()
    // warning - technical debt -
    // API returns WAITING in most cases (but CANCELLED after some time)
    // We expect the inquiry to be cancelled if no proposals to get around this issue
    if (!stores.inquiries.inquiry.proposals.length) {
      history.push(PagesPaths.INQUIRIES.path)
    }
  }

  get content () {
    const { inquiry, payment, selected } = stores.inquiries
    switch (inquiry.status) {
      case InquiryStatus.WAITING:
        return (
          <ProposalsWaiting
            type={this.type}
            inquiry={inquiry}
            frequency={this.frequency}
            selected={selected}
            onSelect={(id) => this.selected(id)}
            payment={payment}
        />
        )
      case InquiryStatus.ACCEPTED:
        const proposal = inquiry.proposals.find((p) => p.status === ProposalStatus.ACCEPTED)
        return (
          <ProposalsAccepted
            type={this.type}
            inquiry={inquiry}
            proposal={proposal}
            payment={payment}
            frequency={this.frequency}
            avanceImmediateEnabled={stores.avanceImmediate.infos && stores.avanceImmediate.infos.usesAvanceImmediate}
        />
        )
      default:
        return (<span />)
    }
  }

  render () {
    const { location, t } = this.props
    const { inquiry } = stores.inquiries
    const hasError = location && location.search.includes('error')

    if (!this.ready) {
      return (<Loader />)
    }

    return (
      <InquiryDetails inquiry={inquiry} account={stores.account.connected} onCloseSearch={() => this.onCloseSearch()}>
        {
          hasError
          ? <InquiryDetailsTextBlock title={t('common:api:an_error_occured')} message={t('common:payment:error')} className='text-color--error' />
          : ''
        }
        { this.content }
      </InquiryDetails>
    )
  }
}

InquiryRealisationPageComponent.propTypes = {
  t: func,
  match: object
}

export const InquiryRealisationPage = withRouter(translate()(view(InquiryRealisationPageComponent)))



// WEBPACK FOOTER //
// ./src/pages/demandes/realisations/InquiryRealisationPage.js